import React, { useEffect, useState } from "react"
import { MobileStepper } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import Markdown from "../utils/Markdown"
import RadioGroup from "@mui/material/RadioGroup"
import FormControlLabel from "@mui/material/FormControlLabel"
import TextField from "@mui/material/TextField"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { styled } from "@mui/material/styles"
import Button from "@mui/material/Button"
import { yupResolver } from "@hookform/resolvers/yup"
import LinearProgress from "@mui/material/LinearProgress"
import * as yup from "yup"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "./style.scss"
import UploadSuccess from "../UploadSuccess/index"
import {
  getDocumentVerification,
  getDocumentTypes,
  uploadDocument,
} from "../../data/index"
import { format } from "date-fns"
import Box from "@mui/material/Box"
import config from "../../config"

const FILE_EXTENTION_LIST = config.fileExtentionList
const FILE_SIZE_LIMIT = config.fileSizeLimit
const TOTAL_FILE_SIZE_LIMIT = config.totalFilesizeLimit
const marketingDomain = process.env.REACT_APP_MARKETING_GATEWAY_URL
const schema = yup
  .object()
  .shape({
    lastName: yup.string().required("Required"),
    dob: yup.string().nullable().required("Required"),
    referenceId: yup.string().required("Required"),
  })
  .required()

const Input = styled("input")({
  display: "none",
})

function index({ contentData }) {
  const [nextDisable, setNextDisable] = useState(false)
  const [disableFileCheck, setDisableFileCheck] = useState(false)
  const [disableSubmitCheck, setDisableSubmitCheck] = useState(false)
  const [step, setStep] = useState(0)
  // const [dob, setDob] = useState(null)
  const [documentType, setDocumentType] = useState("")
  const [documentTypeList, setDocumentTypeList] = useState([])
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [totalFileSize, setTotalFileSize] = useState(0)
  const [status, setStatus] = useState("")
  const [responseToken, setResponseToken] = useState("")
  let [loading, setLoading] = useState(false)
  let fileSize = 0

  useEffect(() => {
    if (uploadedFiles.length > 0) {
      const checkFileInvalid = [...uploadedFiles].find(
        item => item.status === "invalid"
      )
      const checkFileBig = [...uploadedFiles].find(
        item => item.status === "bigfile"
      )
      if (
        checkFileInvalid?.status === "invalid" ||
        checkFileBig?.status === "bigfile"
      ) {
        setDisableFileCheck(true)
      } else {
        setDisableFileCheck(false)
      }
    } else {
      setDisableFileCheck(true)
    }
  }, [uploadedFiles])

  const setPrivacyLink = url => {
    return url
      ? url.replace("(/privacy/)", "(" + marketingDomain + "privacy)")
      : ""
  }

  const methods = useForm({
    resolver: yupResolver(schema),
    // mode: "all",
    defaultValues: {
      lastName: "",
      dob: "",
      referenceId: "",
    },
  })

  const { register, handleSubmit, errors, control } = methods
  const onSubmit = async submitData => {
    try {
      setNextDisable(true)
      setResponseToken("")
      const reqDateFormat = format(new Date(submitData.dob), "dd-MM-yyyy")
      const requestData = {
        "record-identifier": submitData.referenceId.toUpperCase(),
        "last-name": submitData.lastName.toLowerCase(),
        "birth-date": reqDateFormat,
      }
      setLoading(true)
      const response = await getDocumentVerification(requestData)
      const { errorCode = "", data = "", success = "" } = response
      if (data) {
        setStatus("")
        setResponseToken(success)
        const resDocumentTypes = await getDocumentTypes()
        const { data = [] } = resDocumentTypes
        data.sort(sortDocumentTypes("documentType"))
        setDocumentTypeList(data)
        setStep(prevState => prevState + 1)
      } else {
        if (
          errorCode === "SFDUP_TEC_00001" ||
          errorCode === "SFDUP_BIZ_00003"
        ) {
          setStatus(contentData.errorMessage)
        } else if (errorCode === "SFDUP_BIZ_00001") {
          setStatus("Missing valid record identifier.")
        } else if (errorCode === "SFDUP_BIZ_00002") {
          setStatus("At least two input parameters are required.")
        } else {
          setStatus("Error")
        }
      }
      setNextDisable(false)
      setLoading(false)
    } catch (err) {
      setNextDisable(false)
      return err
    }
  }

  const handleDocumentType = event => {
    setDocumentType(event.target.value)
  }
  function sortDocumentTypes(prop) {
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1
      } else if (a[prop] < b[prop]) {
        return -1
      }
      return 0
    }
  }
  const handleFinalStep = async () => {
    if (totalFileSize < TOTAL_FILE_SIZE_LIMIT) {
      const response = []
      for (var i = 0; i < uploadedFiles.length; i++) {
        const formData = new FormData()
        formData.append("metadata.requestToken", responseToken.metadata)
        formData.append(
          "metadata.monumentRefId",
          uploadedFiles[i].monumentRefId
        )
        formData.append(
          "metadata.documentName",
          uploadedFiles[i].fileUpload.name
        )
        formData.append(
          "file",
          uploadedFiles[i].fileUpload,
          uploadedFiles[i].fileUpload.name
        )
        setDisableSubmitCheck(true)
        response.push(uploadDocument(formData, cb, i))
      }

      Promise.allSettled(response)
        .then(res => {
          let counterStatus = 0
          for (var i = 0; i < res.length; i++) {
            const { value = {} } = res[i]
            const { data = {} } = value
            const { data: mainData = {}, errorCode = "" } = data
            if (errorCode) {
              setDisableSubmitCheck(false)
              cb(undefined, i, errorCode)
            } else {
              const { documentId = "" } = mainData
              if (documentId) {
                cb(100, i)
                counterStatus++
              } else {
                setDisableSubmitCheck(false)
                const { status } = res[i]
                const { response } = res[i].reason
                if (status === "rejected" && !response) {
                  cb(undefined, i)
                } else {
                  cb(undefined, i)
                }
              }
            }
          }
          if (counterStatus > 0 && counterStatus === res.length) {
            // Added 1 second delay so that the progress bar willshow 100%.
            setTimeout(() => {
              setStep(3)
            }, 1000)
          }
        })
        .catch(err => {
          if (err && Array.isArray(err)) {
            err.forEach(err => cb(undefined, index, err))
          }
        })
    }
    // setStep(3)
  }

  function cb(data, counter, status) {
    const updatedData = [...uploadedFiles]
    const index = updatedData.findIndex(
      (item, childIndex) => childIndex === counter
    )
    if (index >= 0) {
      updatedData[index].value = data
      updatedData[index].status = status
    }
    setUploadedFiles(updatedData)
    setDocumentType("")
  }

  function getFile(filePath) {
    return filePath.slice(((filePath.lastIndexOf(".") - 1) >>> 0) + 2)
  }

  function checkExtension(ext) {
    let fileExtensionArray = FILE_EXTENTION_LIST
    return fileExtensionArray.indexOf(ext) > -1
  }

  const handleFileUpload = event => {
    if (event.target.files && event.target.files[0]) {
      const extension = getFile(event.target.files[0].name).toLowerCase()
      // setUploadedFiles(prevState => [...prevState, event.target.files[0]])
      const data = documentTypeList.filter(
        item => item.documentType === documentType
      )
      setTotalFileSize(prevState => prevState + event.target.files[0].size)
      // Check if uploadefile is not more than FILE_SIZE_LIMIT.
      if (event.target.files[0].size > FILE_SIZE_LIMIT) {
        setUploadedFiles(prevState => [
          ...prevState,
          {
            name: documentType,
            monumentRefId: data[0].monumentRefId,
            fileUpload: event.target.files[0],
            value: undefined,
            status: "bigfile",
          },
        ])
      } else {
        if (checkExtension(extension)) {
          setUploadedFiles(prevState => [
            ...prevState,
            {
              name: documentType,
              monumentRefId: data[0].monumentRefId,
              fileUpload: event.target.files[0],
              value: 0,
              status: "",
            },
          ])
        } else {
          setUploadedFiles(prevState => [
            ...prevState,
            {
              name: documentType,
              monumentRefId: data[0].monumentRefId,
              fileUpload: event.target.files[0],
              value: undefined,
              status: "invalid",
            },
          ])
        }
      }

      setDocumentType("")
    }
  }

  const handleDelete = parentIndex => {
    let filteredArray = uploadedFiles.filter(
      (item, index) => index !== parentIndex
    )
    setTotalFileSize(
      prevState => prevState - uploadedFiles[parentIndex].fileUpload.size
    )
    setUploadedFiles(filteredArray)
    setDocumentType("")
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const getRadio = index => {
    if (index === 0) {
      return (
        <img
          className="circleRadioIcon"
          src={
            step === 0
              ? contentData?.circleRadioOn?.url
              : contentData?.circleRadioCompleted?.url
          }
          alt={
            step === 0
              ? contentData?.circleRadioOn?.fileName
              : contentData?.circleRadioCompleted?.fileName
          }
        />
      )
    } else {
      return (
        <img
          className="circleRadioIcon"
          src={
            step === 0
              ? contentData?.circleRadioOff?.url
              : contentData?.circleRadioOn?.url
          }
          alt={
            step === 0
              ? contentData?.circleRadioOff?.fileName
              : contentData?.circleRadioOn?.fileName
          }
        />
      )
    }
  }

  const getRadioContent = () => {
    const { uploadOptions = {} } = contentData
    const { optionsCollection = {} } = uploadOptions
    const { items = [] } = optionsCollection
    return items.map((item, index) => {
      return (
        <FormControlLabel
          checked={step === index}
          key={index}
          value={item.value}
          className="radio-document"
          label={item.label}
          disabled={index !== 0 ? step !== index : false}
          control={getRadio(index)}
        />
      )
    })
  }

  const showProgress = data => {
    if (data.value > 0) {
      return (
        <>
          <LinearProgress
            className="progressBar noSpacing"
            variant="determinate"
            value={data.value}
          />
          <div className="uploadingProgress">
            <div>
              {formatBytes((data?.fileUpload?.size / 100) * data?.value, 0)} of{" "}
              {formatBytes(data?.fileUpload?.size, 0)}
            </div>
            <div>Uploading... {data.value}%</div>
          </div>
        </>
      )
    } else if (data.value === 0) {
      return (
        <>
          <LinearProgress
            className="progressBar"
            variant="determinate"
            value={data.value}
          />
          <div className="errorProgress" />
        </>
      )
    } else {
      const { status } = data
      let errStatus
      if (status === "DCMNT_BIZ_2009") {
        errStatus = "Document metadata is missing"
      } else if (status === "DCMNT_BIZ_2003") {
        errStatus = "Monument reference id is not valid"
      } else if (status === "DCMNT_BIZ_2004") {
        errStatus = "Application number or account number is required"
      } else if (status === "DCMNT_BIZ_2002") {
        errStatus = "Document size is not within limits"
      } else if (status === "DCMNT_BIZ_2011") {
        errStatus = "Uploaded document is infected"
      } else if (status === "DCMNT_BIZ_2012") {
        errStatus = "Unable to scan document"
      } else if (status === "DCMNT_BIZ_2008") {
        errStatus = "Document is not readable"
      } else if (status === "DCMNT_BIZ_400") {
        errStatus = "Validation error(s) are found"
      } else if (status === "DCMNT_BIZ_2010") {
        errStatus = "Document not empty"
      } else if (status === "DCMNT_BIZ_2007") {
        errStatus = "Document format is not supported"
      } else if (status === "invalid") {
        errStatus = `${data?.fileUpload?.name} is invalid extension`
      } else if (status === "bigfile") {
        errStatus = `${data?.fileUpload?.name} should be less than 10MB`
      } else {
        errStatus = "Error"
      }
      return (
        <>
          <LinearProgress
            className="errorProgressBar"
            variant="determinate"
            value={0}
          />
          <div className="errorText">{errStatus}</div>
        </>
      )
    }
  }

  return (
    <>
      <div className="container">
        <div className="mainBox">
          <div className="uploadBox">
            {contentData.error ? (
              <div className="heading">
                Something went wrong. Please try again.
              </div>
            ) : step === 0 || step === 1 ? (
              <>
                <div className="heading">{contentData?.title}</div>
                <div className="stepContainer">
                  <div className="chevronIcon" />
                  <MobileStepper
                    className={`step ${
                      step === 0
                        ? "css-qhoknl-MuiLinearProgress-bar1-step1"
                        : "css-qhoknl-MuiLinearProgress-bar1-step2"
                    }`}
                    variant="progress"
                    position="static"
                    activeStep={step}
                    LinearProgressProps={{
                      variant: "buffer",
                      value: step > 0 ? 100 : 50,
                      valueBuffer: 100,
                    }}
                    sx={{ flexGrow: 1 }}
                  />
                </div>
                <form
                  autoComplete="off"
                  encType="multipart/form-data"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    className="radioGroup"
                  >
                    {getRadioContent()}
                  </RadioGroup>
                  {step === 0 && (
                    <>
                      <TextField
                        data-testid="lastName"
                        name="lastName"
                        margin="normal"
                        placeholder="Last name"
                        error={
                          errors && errors.lastName && errors.lastName.message
                        }
                        inputRef={register}
                        inputProps={{ maxLength: 100 }}
                        helperText={
                          errors && errors.lastName && errors.lastName.message
                        }
                      />
                      <Controller
                        name="dob"
                        render={({ onChange, value }) => (
                          <DatePicker
                            selected={value ? value : ""}
                            onChange={onChange}
                            maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            className="custom-datePicker"
                            placeholderText="Date of birth (dd/mm/yyyy)"
                          />
                        )}
                        control={control}
                        valueName="selected"
                      />
                      <div className="errorText">
                        {errors && errors.dob && errors.dob.message}
                      </div>
                      <TextField
                        name="referenceId"
                        margin="normal"
                        placeholder="Reference ID"
                        error={
                          errors &&
                          errors.referenceId &&
                          errors.referenceId.message
                        }
                        inputRef={register}
                        inputProps={{ maxLength: 10 }}
                        helperText={
                          errors &&
                          errors.referenceId &&
                          errors.referenceId.message
                        }
                      />
                      {status && <div className="errorText">{status}</div>}
                      <button
                        type="submit"
                        data-testid="button-next"
                        className="button__primary button_next"
                        disabled={nextDisable}
                      >
                        {contentData?.nextButtonLabel}
                      </button>
                      {loading && <div id="cover-spin"></div>}
                    </>
                  )}
                  {step === 1 && (
                    <>
                      {uploadedFiles.length > 0 && (
                        <div className="upload-progress-data">
                          {uploadedFiles.map((item, index) => {
                            fileSize = item.fileUpload.size
                            return (
                              <div key={index}>
                                <div className="document-heading">
                                  {/* {contentData.documentTypeHeading} */}
                                  {item.name}
                                </div>
                                <hr className="line-break line-margin" />
                                <div className="upload-data">
                                  <div className="upload-file">
                                    {item?.fileUpload?.name}
                                  </div>
                                  <div
                                    role="button"
                                    onClick={() => handleDelete(index)}
                                    onKeyDown={() => handleDelete(index)}
                                    tabIndex={index}
                                  >
                                    <img
                                      className="button-deleteIcon"
                                      src={contentData?.deleteIcon?.url}
                                      width="16"
                                      height="16"
                                      alt={contentData?.deleteIcon?.fileName}
                                    />
                                  </div>
                                </div>
                                {item?.status !== "invalid" &&
                                fileSize > FILE_SIZE_LIMIT ? (
                                  <>
                                    <LinearProgress
                                      className="errorProgressBar"
                                      variant="determinate"
                                      value={item?.value}
                                    />
                                    <div className="errorText">
                                      File size {formatBytes(fileSize, 0)}- File
                                      must be smaller than 10MB
                                    </div>
                                  </>
                                ) : (
                                  <Box sx={{ width: "100%" }}>
                                    {showProgress(item)}
                                  </Box>
                                )}
                                <hr
                                  className={`line-break ${
                                    index === uploadedFiles.length - 1 &&
                                    "last-lineBreak"
                                  }`}
                                />
                              </div>
                            )
                          })}
                        </div>
                      )}
                      <div className="upload-container">
                        {/* <InputLabel htmlFor="age-simple">Age</InputLabel> */}
                        <Select
                          name="select-document-type"
                          displayEmpty
                          renderValue={selected => {
                            if (selected.length === 0) {
                              return "Document type"
                            }
                            return selected
                          }}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={documentType}
                          data-testid="document-type"
                          className="document-type"
                          onChange={handleDocumentType}
                          MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
                        >
                          {documentTypeList.length > 0 &&
                            documentTypeList.map(item => (
                              <MenuItem
                                key={item.monumentRefId}
                                value={item.documentType}
                              >
                                {item.documentType}
                              </MenuItem>
                            ))}
                        </Select>
                        <label htmlFor="contained-button-file">
                          <Input
                            id="contained-button-file"
                            type="file"
                            name="file"
                            className="fileUpload"
                            accept="image/png, image/gif, image/jpeg, image/jpg, image/jfif, image/bmp, image/tif, image/tiff, application/pdf, .rtf, .tif, .txt, .doc, .docx, .xlsx, .xls, application/vnd.oasis.opendocument.text"
                            onChange={handleFileUpload}
                            disabled={documentType === ""}
                            onClick={event => {
                              event.target.value = null
                            }}
                          />
                          <Button
                            disableRipple={documentType === ""}
                            className={`button-upload ${
                              documentType === "" && "button-disabled"
                            }`}
                            variant="outlined"
                            component="span"
                          >
                            {contentData?.uploadButtonLabel}
                          </Button>
                        </label>
                      </div>
                      {totalFileSize >= TOTAL_FILE_SIZE_LIMIT ? (
                        <div className="allFilesErrorText">
                          Total Files size {formatBytes(totalFileSize, 0)}-Total
                          Files size must be smaller than 50MB.
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="doc-notice">
                        <Markdown
                          source={setPrivacyLink(
                            contentData?.documentTypeNotice
                          )}
                        />
                      </div>
                      <button
                        type="button"
                        data-testid="button"
                        className="button__primary"
                        onClick={handleFinalStep}
                        disabled={
                          totalFileSize > TOTAL_FILE_SIZE_LIMIT ||
                          disableFileCheck ||
                          disableSubmitCheck
                        }
                      >
                        Submit
                      </button>
                    </>
                  )}
                  <div className="notice">
                    <Markdown
                      source={setPrivacyLink(contentData?.privacyNotice)}
                    />
                  </div>
                </form>
              </>
            ) : (
              <UploadSuccess contentData={contentData} />
            )}
          </div>
        </div>
        {!contentData.error ? (
          <>
            <img
              className="rightBackgroundImg"
              src={contentData?.backgroundLightGrey?.url}
              width="358"
              height="468"
              alt="lightGrey"
            />
            <img
              className="rightBackgroundDarkImg"
              src={contentData?.backgroundGrey?.url}
              width="576"
              height="383"
              alt="darkGrey"
            />
          </>
        ) : (
          ""
        )}
      </div>
    </>
  )
}

export default index
